import { getInstance } from './auth0-plugin'

const maintenance = JSON.parse(process.env.VUE_APP_MAINTENANCE_STATUS)

export const authGuard = (to, from, next, guardOptions) => {
  const authService = getInstance()

  const { entities, writeActions } = guardOptions
  const writeScopes = authService.buildScopes(entities, writeActions)

  const guardAction = () => {
    if (authService.isAuthenticated) {
      if (authService.tenantTitle) {
        document.title = `${authService.tenantTitle} | ${to.meta.title}`
      }
      if (maintenance) {
        if (to.path !== '/') return next('/')
        else return next()
      }
      if (to.meta.requiresWriteAccess) {
        const hasWriteAccess = authService.checkScopes(writeScopes)
        if (!hasWriteAccess) {
          return next('/')
        }
      }
      if (to.meta.adminOnly && !authService.isAdmin) {
        return next('/')
      }
      return next()
    }
    const options = { appState: { targetUrl: to.fullPath } }
    authService.loginWithRedirect({ ...options })
  }

  // If the Auth0Plugin has loaded already, check the authentication state
  if (!authService.isLoading) {
    return guardAction()
  }

  authService.$watch('isLoading', (isLoading) => {
    if (isLoading === false) {
      return guardAction()
    }
  })
}



// WEBPACK FOOTER //
// ./src/auth/authGuard.js